var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-971 -1246)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(971 1246)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "inherit",
    d: "M992.4 1256.148a2.43 2.43 0 0 0-2.313-2.538c-1.731-.081-3.5-.113-5.3-.113h-.567c-1.8 0-3.569.031-5.3.113a2.435 2.435 0 0 0-2.311 2.545c-.078 1.112-.109 2.225-.109 3.338s.031 2.225.106 3.341a2.438 2.438 0 0 0 2.31 2.547c1.819.084 3.684.117 5.584.117s3.76-.031 5.582-.119a2.438 2.438 0 0 0 2.313-2.547c.075-1.116.109-2.228.106-3.344s-.03-2.224-.101-3.34Zm-9.426 6.41v-6.141l4.526 3.069Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.897bad46981f89b4249c84980c15361c.svg";
export { ForwardRef as ReactComponent };